import React, { useState } from 'react';
import { Button, Checkbox, Col, Form, Input, notification, Row } from 'antd';
import _ from 'lodash';
import axios from 'axios';
import {
  PRIVACY_POLICY_URL,
  TERMS_AND_CONDITIONS_URL,
} from '../../../AppConstants';

export const namePattern =
  /^[a-zA-Z0-9\s\-'`àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆŠŽ∂ð]*$/;

export default function UserForm() {
  const [created, setCreated] = useState(false);
  const [, setCreatedMessage] = useState(null);

  const sendDataToServer = (data) => {
    let payload_data = {
      email: data.email,
      password: data.password,
      first_name: data.first_name,
      last_name: data.last_name,
      is_news_subscribed: Boolean(data?.agreement2),
    };

    axios
      .post('signup', payload_data)
      .then((res) => {
        if (res.status === 200) {
          let result = res.data.result;
          notification.success({
            message: <div className='gSemiBold'>Success!</div>,
            style: { border: '1px #2CB972 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Success',
          });
          window.scrollTo(0, 0);
          setCreated(true);
          setCreatedMessage(result);
        } else {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Error processing request',
          });
        }
      })
      .catch((err) => {
        if (err.response.status === 500) {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Server Response failed. Please try again later',
          });
        } else if (err.response.status === 401) {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description:
              'Your action will not be saved. Please Login and try again!',
          });
        } else if (err.response.status === 400) {
          notification.warning({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: err.response.data['detail'],
          });
        } else if (err.response.status === 422) {
          if (err.response.data['detail'] === 'Signature has expired') {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description:
                'Login session has been expired. Please Login to continue!',
            });
          } else {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description:
                "OOPS! Server didn't like the request. If this persists please contact support team",
            });
          }
        } else if (err.response.status === 423) {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description:
              'Sorry ! this booking slot has been booked by another user, Try different booking!',
          });
        }
      })
      .finally(() => {});
  };

  const onFinishLogin = (values) => {
    if (_.isEqual(values.password, values.password1)) {
      sendDataToServer(values);
    } else {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description: "Your passwords don't match. Please try again.",
      });
    }
  };

  const onFinishFailed = () => {};

  const labelClasses = 'dark-swim-blue gSemiBold mg-bottom-5 fs-16';

  return (
    <Row>
      <Col span={24} id='angler-signup-form-input'>
        {/*  */}
        {!created ? (
          <Form
            name='basic'
            initialValues={{
              remember: true,
            }}
            onFinish={onFinishLogin}
            onFinishFailed={onFinishFailed}
          >
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col
                className='gutter-row'
                xs={24}
                sm={12}
                lg={12}
                md={12}
                xl={12}
                xxl={12}
                span={12}
              >
                <p className={labelClasses}>First Name*</p>
                <Form.Item
                  name='first_name'
                  rules={[
                    {
                      required: true,
                      message: 'Please input firstname!',
                    },
                    {
                      pattern: namePattern,
                      message: 'Unsupported character in first name',
                    },
                  ]}
                >
                  <Input className='br5 fname' />
                </Form.Item>
              </Col>
              <Col
                className='gutter-row'
                xs={24}
                sm={12}
                lg={12}
                md={12}
                xl={12}
                xxl={12}
                span={12}
              >
                <p className={labelClasses}>Last Name*</p>
                <Form.Item
                  name='last_name'
                  rules={[
                    {
                      required: true,
                      message: 'Please input lastname!',
                    },
                    {
                      pattern: namePattern,
                      message: 'Unsupported character in last name',
                    },
                  ]}
                >
                  <Input className='br5 lname' />
                </Form.Item>
              </Col>
            </Row>

            <p className={labelClasses}>Email Address*</p>
            <Form.Item
              name='email'
              rules={[
                {
                  required: true,
                  message: 'Please input email!',
                },
              ]}
            >
              <Input type='email' className='br5 email' />
            </Form.Item>

            <p className={labelClasses}>Create Password*</p>
            <Form.Item
              name='password'
              rules={[
                {
                  required: true,
                  message: 'Please input your password!',
                },
              ]}
            >
              {/* <PasswordInput /> */}
              <Input.Password className='br5' />
            </Form.Item>

            <p className={labelClasses}>Confirm Password*</p>
            <Form.Item
              name='password1'
              rules={[
                {
                  required: true,
                  message: 'Cannot be empty!',
                },
              ]}
            >
              <Input.Password className='br5' />
            </Form.Item>

            <Form.Item
              name='agreement'
              valuePropName='checked'
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject('Should accept terms and conditions'),
                },
              ]}
            >
              <Checkbox>
                <span className='gLight fs-15'>
                  By creating an account, I verify that I agree with
                  swimbooker's
                  <a
                    href={PRIVACY_POLICY_URL}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='gRegular signup-terms-content'
                    style={{ color: '#24689E' }}
                  >
                    data policy
                  </a>{' '}
                  and
                  <a
                    href={TERMS_AND_CONDITIONS_URL}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='gRegular sb-blue signup-terms-content'
                  >
                    terms and conditions.
                  </a>
                </span>
              </Checkbox>
            </Form.Item>

            <Form.Item name='agreement2' valuePropName='checked'>
              <Checkbox>
                <span className='gLight fs-15'>
                  Keep me up to date with swimbooker's new fisheries, updates,
                  news and content.
                </span>
              </Checkbox>
            </Form.Item>

            <Form.Item>
              <Button
                className='admin-login-btn light-green-bg gBold'
                type='primary'
                htmlType='submit'
              >
                Get Started
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <>
            <p className='txt-center fs-32 gBold mg-bottom-10'>
              Welcome to swimbooker!
            </p>
            <p className='txt-center fs-22 gLight mg-bottom-10'>
              Next Step:{' '}
              <span className='gBold seagreen'>Check your email address.</span>
            </p>
            {/* <div className="success-signup-message-info"> */}
            <p className='txt-center fs-22 gSemiBold mg-bottom-10'>
              1. Log into your email account.
            </p>
            <p className='txt-center fs-22 gSemiBold'>
              2. Follow the link inside the email to complete your profile.
            </p>
            {/* </div> */}
            <p className='gLight fs-18 txt-center'>
              Note: If you can't see an email, please also check your 'junk'
              folder. Any issues, please{' '}
              <a className='' href='/contact'>
                contact us.
              </a>
            </p>
            <div className='center gSemiBold'>
              <a href='/' className='row-center join-sbplus-btn'>
                Return to home
              </a>
            </div>
          </>
        )}

        {/*  */}
      </Col>
    </Row>
  );
}
